<template>
  <div class="workspace__container__view">
    <div class="workspace__container__view__header">
      <div class="workspace__container__view__header__actions">
        <button @click="createOrEdit()">{{ $t("workspace.spot.create_spot") }}</button>
      </div>
      <div class="workspace__container__view__header__filter filter-spot">
        <div class="container__inputs">
          <div class="settings-input"> 
            <Multiselect
              v-model="filterModel.stationId"
              :placeholder="$t('workspace.spot.all_station')"
              track-by="name"
              valueProp="id"
              label="name"
              :searchable="true"
              :options="listStations"
              @select="search(true)" @clear="search(true)" />
          </div>
          <div class="settings-input">
            <Multiselect
              v-model="filterModel.adAgencyId"
              :placeholder="$t('workspace.spot.all_ad_agency')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="true"
              :options="listAgencies"
              @select="search(true)" @clear="search(true)" />
          </div>
          <div class="settings-input">
            <Multiselect
              v-model="filterModel.clientId"
              :placeholder="$t('workspace.spot.all_customer')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="true"
              :options="listClients"
              @select="search(true)" @clear="search(true)" />
          </div>
          <div class="settings-input tooltip-search">
            <input type="text" v-model="filterModel.name" :placeholder="$t('workspace.spot.all_name')" @keypress="editName = true" @keypress.enter="search(true); editName = false; editInternalOrderNumber = false; editAgNumber = false; editFileName = false;">
            <Transition>
              <div v-if="editName && filterModel.name != ''" v-html="$t('workspace.spot.press_enter')"></div>
            </Transition>
          </div>
          <div class="settings-input tooltip-search">
            <input type="text" v-model="filterModel.fileName" :placeholder="$t('workspace.spot.all_fileName')" @keypress="editFileName = true" @keypress.enter="search(true); editName = false; editInternalOrderNumber = false; editAgNumber = false; editFileName = false;">
            <Transition>
              <div v-if="editFileName && filterModel.fileName != ''" v-html="$t('workspace.spot.press_enter')"></div>
            </Transition>
          </div>
          <div class="settings-input tooltip-search">
            <input type="number" step="1" pattern="[0-9]" v-model="filterModel.internalOrderNumber" :placeholder="$t('workspace.spot.all_internal_number')" @keypress="editInternalOrderNumber = true" @keypress.enter="search(true); editName = false; editInternalOrderNumber = false; editAgNumber = false; editFileName = false;">
            <Transition>
              <div v-if="editInternalOrderNumber && filterModel.internalOrderNumber != ''" v-html="$t('workspace.spot.press_enter')"></div>
            </Transition>
          </div>
          <div class="settings-input tooltip-search">
            <input type="text" v-model="filterModel.agencyOrderNumber" :placeholder="$t('workspace.spot.all_agency_number')" @keypress="editAgNumber = true" @keypress.enter="search(true); editName = false; editInternalOrderNumber = false; editAgNumber = false">
            <Transition>
              <div v-if="editAgNumber && filterModel.agencyOrderNumber != ''" v-html="$t('workspace.spot.press_enter')"></div>
            </Transition>
          </div>
          <div class="settings-checkbox">
            <input type="checkbox" name="active" id="active" v-model="filterModel.active" @change="search(true)">
            <label for="active" :title="$t('workspace.spot.active_title')">{{$t('workspace.spot.active')}}</label>
          </div>
        </div>
        <button @click="clearFilters" :disabled="disabledCleanFilter">
          <i class="material-icons" style="font-size: 20px">filter_alt_off</i>
        </button>

      </div>
    </div>
    <strong class="alert-tomato" v-if="!filterModel.active">
      <i class="material-icons">info</i> {{ $t('workspace.spot.active_alert') }}
    </strong>
    <div class="table-scroll">
      <table class="workspace__container__view__table with-padding">
        <thead>
          <tr>
            <th>
              <div class="column-filtered" @click="(sortSpot.filter == 'stationName' ? sortSpot.desc = !sortSpot.desc : sortSpot.filter = 'stationName'); orderSpots()">
                <span>{{ $t("workspace.spot.station") }}</span>
                <i class="material-icons" :class="{'active': sortSpot.filter == 'stationName'}">{{sortSpot.filter == 'stationName' ? (sortSpot.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th>
              <div class="column-filtered" @click="(sortSpot.filter == 'adAgencyName' ? sortSpot.desc = !sortSpot.desc : sortSpot.filter = 'adAgencyName'); orderSpots()">
                <span>{{ $t("workspace.spot.ad_agency") }}</span>
                <i class="material-icons" :class="{'active': sortSpot.filter == 'adAgencyName'}">{{sortSpot.filter == 'adAgencyName' ? (sortSpot.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th>
              <div class="column-filtered" @click="(sortSpot.filter == 'customerName' ? sortSpot.desc = !sortSpot.desc : sortSpot.filter = 'customerName'); orderSpots()">
                <span>{{ $t("workspace.spot.customer") }}</span>
                <i class="material-icons" :class="{'active': sortSpot.filter == 'customerName'}">{{sortSpot.filter == 'customerName' ? (sortSpot.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th>
              <div class="column-filtered" @click="(sortSpot.filter == 'spotName' ? sortSpot.desc = !sortSpot.desc : sortSpot.filter = 'spotName'); orderSpots()">
                <span>{{ $t("workspace.spot.name") }}</span>
                <i class="material-icons" :class="{'active': sortSpot.filter == 'spotName'}">{{sortSpot.filter == 'spotName' ? (sortSpot.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th class="float-right">
              <div class="column-filtered" @click="(sortSpot.filter == 'internalNumber' ? sortSpot.desc = !sortSpot.desc : sortSpot.filter = 'internalNumber'); orderSpots()">
                <span>{{ $t("workspace.spot.internal_number") }}</span>
                <i class="material-icons" :class="{'active': sortSpot.filter == 'internalNumber'}">{{sortSpot.filter == 'internalNumber' ? (sortSpot.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th class="float-right">
              <div class="column-filtered" @click="(sortSpot.filter == 'agencyOrderNumber' ? sortSpot.desc = !sortSpot.desc : sortSpot.filter = 'agencyOrderNumber'); orderSpots()">
                <span>{{ $t("workspace.spot.agency_number") }}</span>
                <i class="material-icons" :class="{'active': sortSpot.filter == 'agencyOrderNumber'}">{{sortSpot.filter == 'agencyOrderNumber' ? (sortSpot.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th class="actions">{{ $t("workspace.spot.actions") }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="listSpots.length > 0">  
            <tr v-for="item in listSpots" :key="item.code" :class="{'text-tomato': !item.active}">
              <td v-html="item.stationName"></td>
              <td v-html="item.adAgencyName || '-'"></td>
              <td v-html="item.customerName || '-'"></td>
              <td v-html="item.spotName || '-'"></td>
              <td class="float-right" v-html="item.internalNumber || '-'"></td>
              <td class="float-right" v-html="item.agencyOrderNumber || '-'"></td>
              <td class="actions">
                <i class="material-icons" @click="createOrEdit(item.id)">edit</i>
                <i class="material-icons" @click="deleteItem(item)">delete</i>
              </td>
            </tr>
          </template>
          <tr v-if="listSpots.length == 0">
            <td colspan="7">{{$t('workspace.not_have_loaded')}} <strong>{{ $t("left_menu.spot_programming.spot") }}</strong>. {{$t('workspace.please')}} <strong style="text-decoration: underline; cursor: pointer" @click="createOrEdit()">{{ $t("workspace.spot.create_spot") }}</strong></td>
          </tr>
          <tr v-if="(filterModel.pageNumber + 1) * filterModel.rowsPerPage < totalResults">
            <td colspan="7" @click="addPage">
              <strong class="text-load">{{$t('workspace.certificate.more_results')}} <i class="material-icons">keyboard_arrow_down</i></strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { ref } from '@vue/reactivity'
import { useStore } from 'vuex'
import { computed, onMounted } from '@vue/runtime-core';
import { useRoute, useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect';

export default {
  components: {
    Multiselect
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const totalResults = ref(0);
    const tabActive = computed(() => store.getters.tabs_getActive);
    const listSpots = computed(() => store.getters.spots_spots)
    const listStations = computed(() => store.getters.station_stations({name: ''}));
    const listAgencies = computed(() => store.getters.adAgency_agenciesList);
    const listClients = computed(() => store.getters.client_clientsList);
    const isFilterActive = computed(() => filterModel.value.stationName != '' || filterModel.value.adAgencyName != '' || filterModel.value.customerName != '' || filterModel.value.spotName != '' || filterModel.value.internalNumber != '' || filterModel.value.agencyOrderNumber != '');
    const editInternalOrderNumber = ref(false);
    const editName = ref(false);
    const editAgNumber = ref(false);
    const editFileName = ref(false);
    const disabledCleanFilter = computed(() => {
      const modelClean = {
        stationId: null,
        adAgencyId: null,
        clientId: null,
        spotCategoryId: null,
        name: "",
        fileName: "",
        agencyOrderNumber: "",
        internalOrderNumber: null,
        active: true,
        pageNumber: 0,
        rowsPerPage: 500
      }
      return JSON.stringify(modelClean) == JSON.stringify(filterModel.value); 
    })
    const filterModel = ref({
      stationId: null,
      adAgencyId: null,
      clientId: null,
      spotCategoryId: null,
      name: "",
      fileName: "",
      agencyOrderNumber: "",
      internalOrderNumber: null,
      active: true,
      pageNumber: 0,
      rowsPerPage: 500
    })
    const sortSpot = ref({
      filter: '',
      desc: true
    })

    onMounted(async () => {
      store.dispatch('loading_setActive', true);
      // Esto levanta la busqueda cuando cambia de tab
      if (tabActive.value.extendedData && tabActive.value.extendedData.filterModel) {
        filterModel.value = tabActive.value.extendedData.filterModel;
      }

      // Get values from localStorage
      if (localStorage.getItem('spot_list_sort')) {
        sortSpot.value = JSON.parse(localStorage.getItem('spot_list_sort'));
      } else {
        sortSpot.value = {
          filter: '',
          desc: true
        }
      }

      await store.dispatch('station_getAll');
      await store.dispatch('adAgency_getAll');
      await store.dispatch('client_getAll');
      await search(true);
      store.dispatch('loading_setActive', false);
    });

    async function createOrEdit(id = `create${new Date().getUTCMilliseconds()}`) {
      const tab = {
        id,
        module: 'spot_programming',
        name: 'spot/detail',
        extendedData: {}
      };
      await store.dispatch('tabs_addTab', tab);
      await store.dispatch('tabs_setActive', tab);
      router.push(`/${tab.module}/${tab.name}/${tab.id}`);
    }
    
    async function deleteItem(item) {
      await store.dispatch('modal_setActive', {active: 'COMMON_DELETE', props: item, actionDelete: 'spots_delete'});
    }

    async function search(clean = false) {
      store.dispatch('loading_setActive', true);
      if (clean) {
        await store.dispatch('spots_setSpots', []);
        filterModel.value.pageNumber = 0;
      }

      setTimeout(async () => {
        const model = {...filterModel.value};
        if (model.internalOrderNumber == '') model.internalOrderNumber = null;
        try {
          const response = await store.dispatch('spots_searchNew', model);
          await store.dispatch('tabs_updateTab', {
            id: route.params.id,
            extendedData: {filterModel: model}
          });
          await store.dispatch('spots_setSpots', listSpots.value.concat(response.data));
          totalResults.value = response.totalResults;
          if (sortSpot.value.filter != '') orderSpots();
        } catch (error) {
          console.log(error);
        } finally {
          store.dispatch('loading_setActive', false);
        }
      })
    }

    async function addPage() {
      filterModel.value.pageNumber += 1;
      search();
    }

    const compoundNumberRegex = /^\d+\/\d+$/;

    const orderBy = function (list, property, order) {
      return list.sort((a, b) => {
        const valueA = a[property];
        const valueB = b[property];
        if (typeof valueA === 'number') {
          return order ? (valueA ?? 0) - (valueB ?? 0) : (valueB ?? 0) - (valueA ?? 0);
        } else if (compoundNumberRegex.test(valueA) && compoundNumberRegex.test(valueB)) {
          const [aMain, aSub] = String(valueA).split('/').map(Number);
          const [bMain, bSub] = String(valueB).split('/').map(Number);
          const diff = order ? (aMain - bMain) : (bMain - aMain);
          if (diff !== 0) return diff;
          return order ? (aSub - bSub) : (bSub - aSub);
        } else {
          return order ? (valueA ?? '').localeCompare(valueB ?? '') : (valueB ?? '').localeCompare(valueA ?? '');
        }
      });
    }

    function orderSpots() {
      store.dispatch('spots_setSpots', orderBy(listSpots.value, sortSpot.value.filter, sortSpot.value.desc));
      localStorage.setItem('spot_list_sort', JSON.stringify({
        filter: sortSpot.value.filter,
        desc: sortSpot.value.desc
      }));
    }

    function clearFilters() {
      filterModel.value = {
        stationId: null,
        adAgencyId: null,
        clientId: null,
        spotCategoryId: null,
        name: "",
        fileName: "",
        agencyOrderNumber: "",
        internalOrderNumber: null,
        active: true,
        pageNumber: 0,
        rowsPerPage: 500
      }

      search(true);
    }

    return {
      listSpots,
      listStations,
      listAgencies,
      listClients,
      filterModel,
      isFilterActive,
      totalResults,
      disabledCleanFilter,
      editInternalOrderNumber,
      editName,
      editAgNumber,
      editFileName,
      sortSpot,
      createOrEdit,
      deleteItem,
      addPage,
      search,
      clearFilters,
      orderBy,
      orderSpots
    }
  }
}
</script>
<style lang="scss">
  .alert-tomato {
    display: flex;
    align-items: center;
    color: tomato;
    gap: 8px;
    margin-bottom: 8px;
  }

  th:has(.column-filtered:hover) {
    background: #6060607e;
  }
  .column-filtered {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &:has(th:hover) th {
      background: #6060607e;
    }

    i {
      display: none;
      margin-top: -2px;

      &.active {
        display: block;
      }
    }
  }

  .filter-spot {
    display: flex;
    flex-wrap: nowrap;

    .container__inputs {
      @media screen and (max-width: 1480px) {
        flex-wrap: wrap;
      }

      .settings-input {
        max-width: 200px;
      }
    }
  }

  .tooltip-search {
    position: relative;

    div {
      position: absolute;
      width: 100%;
      border-radius: 8px;
      top: -32px;
      text-align: center;
      background: #7763ff;
      color: white;
      padding: 4px 0;
      transition: all .3s;

      :before {
        content:"\A";
        border-style: solid;
        border-width: 15px 10px 0px 10px;
        border-color: #7763ff transparent transparent transparent;
        position: absolute;
        bottom: -8px;
        left: calc(50% - 5px);
      }
    }
  }

  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
</style>